import React, { useEffect, useState } from "react";
import { SendPostRequest } from "../../http";
import Spinner from "../Spinner";
import { Link } from "react-router-dom";
import HeaderWrapper from "../Header/HeaderWrapper";
import FooterWrapper from "../Footer/FooterWrapper";
import { limitParagraphByCharLimit } from "../../Helper/Helper";
import TextMainBannerWrapper from "../TextMainBanners/TextMainBannerWrapper";

function TrippleStackDesign() {
  const [facilitiesData, setFacilitiesData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    getFacilitiesData();
  }, []);

  const getFacilitiesData = async () => {
    const response = await SendPostRequest("facilities");
    setIsLoading(false);
    setFacilitiesData(response?.data);
  };


  return (
    <div className="page-wrapper-inner">
      <div class="page-wrapper-inner">
        <HeaderWrapper />
        <TextMainBannerWrapper Heading="Our Facilities" Image="theme-2-banner-facilities.webp"/>

        <div className="container">
          <div className="row mt-5">
            <div className="offset-md-2 col-md-8">
              <div className="title-wrap text-center">
                <div className="section-title margin-bottom-60">
                  <h2 className="section-title mb-0 text-uppercase">
                    Provides Our{" "}
                    <span className="theme-color">Best Facilities</span>
                  </h2>
                  <span className="section-border-bottom center"></span>
                </div>
              </div>
            </div>
          </div>

          <div className="row">
            {isLoading ? (
              <div
                style={{ marginBottom: "100px" }}
                className="d-flex align-items-center justify-content-center"
              >
                <Spinner />
              </div>
            ) : facilitiesData?.length === 0 ? (
              <div
                style={{ marginBottom: "100px" }}
                className="d-flex align-items-center justify-content-center"
              >
                <h4>No Record Available</h4>
              </div>
            ) : (
              facilitiesData?.map((data, index) => (
                <div key={index} className="col-lg-4 mb-4 ">
                  <div class="feature-box-wrap f-box-style-4 relative triplestack-specailities-wrapper">
                    <div class="feature-box-details">
                      <div class="feature-img margin-bottom-25">
                        <img className="img-fluid" src={data?.facility_image}
                           style={{ height: "auto" }}
                          alt="feature img" />
                      </div>
                      <div class="feature-content">
                        <div class="feature-title text-center relative margin-bottom-10">
                          <Link
                            to={`/facility/${data?.facility_slug
                              ?.replaceAll(" ", "-")
                              ?.replaceAll("/", "-")}`}
                          >

                            <h5>
                              {data?.facility_title}
                            </h5>
                          </Link>
                        </div>
                        <p class="mb-0 text-center">  <div
                          className="service-desc text-center mb-4"
                          dangerouslySetInnerHTML={{
                            __html:
                              limitParagraphByCharLimit(data?.facility_short_description, 65) +
                              (data?.facility_short_description?.length > 65 ? "..." : ""),
                          }}
                        /></p>
                      </div>
                    </div>
                  </div>
                </div>
              ))
            )}
          </div>
        </div>

        <FooterWrapper />
      </div>
    </div>
  );
}

export default TrippleStackDesign;
